import apiInstance from '@api/index';
import { clearTermsAgreement } from '@pages/TermsAgreement/store/actions';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setGlobalCurrency } from '@store/global/globalSlice';

import {
  AuthApiResponse,
  LoginPayload,
  ResetPasswordPayload,
} from 'types/authTypes';

export const login = createAsyncThunk<
  AuthApiResponse,
  LoginPayload,
  { rejectValue: string }
>('auth/login', async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.auth.login(payload);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.message || 'Login failed');
  }
});

export const logout = createAsyncThunk<
  { message: string },
  void,
  { rejectValue: string }
>('auth/logout', async (_, { rejectWithValue, dispatch }) => {
  try {
    dispatch(clearTermsAgreement());
    const response = await apiInstance.auth.logout();
    return { message: response.data.message };
  } catch (error: any) {
    return rejectWithValue(
      error.message || error.response?.data?.message || 'Logout failed',
    );
  }
});

export const resetPassword = createAsyncThunk<
  { message: string },
  ResetPasswordPayload,
  { rejectValue: string }
>('auth/resetPassword', async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.auth.resetPassword(payload);
    return { message: response.data.message };
  } catch (error: any) {
    return rejectWithValue(error.message || 'Reset password failed');
  }
});

export const verifySession = createAsyncThunk<
  AuthApiResponse,
  void,
  { rejectValue: string }
>('auth/verifySession', async (_, { rejectWithValue, dispatch }) => {
  try {
    const response = await apiInstance.auth.verifySession();
    dispatch(
      setGlobalCurrency({ value: response.data.user.currencyId, label: '' }),
    );

    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.message || 'Session verification failed');
  }
});
